export enum OverviewTabs {
  DOCUMENT = 'document',
  CHANGE_CONTROL = 'change-control',
  TRAINING_ASSESSMENT = 'training',
}

export enum OverviewRoutes {
  CONTENT = 'content',
  CHANGE_CONTROL = 'change-control',
  TRAINING_ASSESSMENT = 'training-assessment',
  TASKS = 'tasks',
}
